/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import Heading from './Heading/index'
import NewPhone from './NewPhone/index'
import Phones from './Phones/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone"
  
}) {
  return (<React.Fragment
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<NewPhone
  viewPath={`${viewPath}/NewPhone`}
/>
{children}
</React.Fragment>)
}